module.exports = __webpack_public_path__ + "static/media/service_private-room.5cc61634.jpg";